var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconModuleInvitations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-d54062e4-0fea-415d-ac5e-ba0cf5647005",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.18,
    height: 12.42,
    viewBox: "0 0 10.18 12.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-7e744e91-c961-42bb-8902-5a52fc33ca2d",
    "data-name": "Object"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.64,6.53c1-.42,1.7-1.4,1.7-2.54,0-1.52-1.24-2.75-2.75-2.75-.1,0-.19.01-.29.02-.56-.76-1.44-1.26-2.45-1.26C2.16,0,.79,1.37.79,3.05c0,1.32.85,2.44,2.03,2.86-1.63.47-2.82,1.98-2.82,3.76v2.59c0,.1.08.17.17.17h9.84c.1,0,.17-.08.17-.17v-2.32c0-1.62-1.08-2.98-2.54-3.4ZM6.59,1.58c1.33,0,2.41,1.08,2.41,2.41s-1.08,2.41-2.41,2.41c-.25,0-.49-.05-.72-.12-.2-.11-.41-.21-.63-.29-.06-.04-.12-.1-.18-.15,1.08-.47,1.83-1.54,1.83-2.79,0-.53-.15-1.03-.39-1.46.03,0,.06,0,.09,0ZM1.14,3.05C1.14,1.56,2.35.34,3.84.34c.93,0,1.75.47,2.24,1.19,0,0,0,0,0,0,.29.43.46.95.46,1.5,0,1.49-1.21,2.7-2.7,2.7s-2.7-1.21-2.7-2.7ZM.34,9.67c0-1.97,1.6-3.57,3.57-3.57.41,0,.81.07,1.18.2.2.13.41.22.63.29,1.05.62,1.76,1.76,1.76,3.07v2.41H.34v-2.41ZM9.84,12.08h-2.01v-2.41c0-1.15-.51-2.19-1.3-2.91.06,0,.12-.02.19-.02,1.72,0,3.13,1.43,3.13,3.19v2.15Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModuleInvitations);
export default __webpack_public_path__ + "static/media/icon_module_invitations.4551af4e4ce5c53a59c3730f93fd9482.svg";
export { ForwardRef as ReactComponent };